import { Pipe, PipeTransform } from '@angular/core';
import { PersonEntity } from '@nk/data-entities-lib';

@Pipe({
  name: 'textToPersonLinkPipe',
})
export class TextToPersonLinkPipe implements PipeTransform {
  public transform(text: string, persons: PersonEntity[]): string {
    if (!text) {
      return '';
    }
    for (const person of persons) {
      const regex = person.full_name;
      text = text.replace(regex, `<a href="/person/${person.person_master_uuid}">${person.full_name}</a>`);
    }
    return text;
  }
}
